module.exports = __webpack_public_path__ + "img/taocan.2f5430dd.jpg";